import { ActiveExpeditionType } from "../../../redux/interfaces/expedition.interface";
import { dateForDatabase } from "../../../utils/dateAndTime";

export const getAwbHistoryRequest = (
  search: Record<string, any>,
  type: ActiveExpeditionType,
) => ({
  type,
  page: search.page || 1,
  perPage: search.rowsPerPage || 25,
  id_client: search.client,
  pctlivrare: search.pctlivrare,
  nodDestinatie: search.nodDestinatie,
  status: search.status,
  doc_trans: search.doc_trans,
  route: search.route,
  coldFilter: search.coldFilter,
  data_crearii: dateForDatabase(search.data_crearii),
});
